<template>
  <el-row class="auth-container flex-full-xs flex-column-items-xs mobile-position-fixed">
    <el-col>
      <el-row
        type="flex"
        justify="center"
        class="links"
      >
        <el-col class="box">
          <div class="clearfix" />
          <el-row
            type="flex"
            justify="center"
            class="auth-form"
          >
            <el-form
              v-loading.fullscreen.lock="loading"
              class="login-signup-form"
              :label-position="labelPosition"
              :model="form"
              :element-loading-background="'rgba(0,0,0,0.7)'"
              @submit.native.prevent="onSubmit"
            >
              <el-col class="title text-center">
                <h1>{{ $t('reset-password.title-text') }}</h1>
              </el-col>
              <el-col>
                <el-form-item :error="error('email')">
                  <el-input
                    v-model="form.email"
                    :placeholder="$t('sign-up.email.placeholder')"
                    @change="change('email')"
                  >
                    <i
                      slot="prefix"
                      class="icon-envelope"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :error="error('password')">
                  <el-input
                    v-model="form.password"
                    :placeholder="$t('sign-up.password.placeholder')"
                    :type="showPassword ? 'text': 'password'"
                    @change="change('password')"
                  >
                    <i
                      slot="prefix"
                      class="icon-lock"
                    />
                    <i
                      slot="suffix"
                      :class="showPassword ? 'icon-blind' : 'icon-eye'"
                      @click="showPassword = !showPassword"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-input
                    v-model="form.password_confirmation"
                    :placeholder="$t('sign-up.re-password.placeholder')"
                    :type="showPasswordConfirm ? 'text': 'password'"
                    @change="change('password')"
                  >
                    <i
                      slot="prefix"
                      class="icon-lock"
                    />
                    <i
                      slot="suffix"
                      :class="showPasswordConfirm ? 'icon-blind': 'icon-eye'"
                      @click="showPasswordConfirm = !showPasswordConfirm"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-button
                    class="submit-button"
                    native-type="submit"
                  >
                    {{ $t('reset-password.title-text') }}
                  </el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="flex-full-xs flex-column-items-xs m-t-xs-30">
      <el-row class="login text-center flex-full-xs flex-column-items-xs">
        <span>{{ $t('sign-up.already-user') }}
          <router-link :to="{ name: 'Login' }">{{ $t('sign-up.login-text') }}<i class="icon-arrow-r" /></router-link>
        </span>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
/* eslint-disable no-unused-vars */

import mutations from '../store/auth/auth.mutationlist';
import Form from '../components/Core/ResourcePage';

export default {
  extends: Form,
  data() {
    return {
      labelPosition: 'left',
      showPassword: false,
      showPasswordConfirm: false,
      form: {
        email: '',
        password: '',
        password_confirmation: '',
      },
    };
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.errors = {};
      this
        .$http
        .post('/auth/password/reset', { ...this.form, token: this.$route.params.token })
        .then((response) => {
          this.loading = false;
          this.$message({ type: 'success',
            message: ` ${this.$t('message.reset-password.done')}`,
          });
          this.$router.push({ name: 'Welcome' });
        })
        .catch(({ response }) => {
          this.onFormError(response);
        });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword.vue